// Personal inboxes cannot open a workspace. Country variants such as yahoo.co.in count too.
const FREE_EMAIL_DOMAIN = /^(gmail\.com|googlemail\.com|(yahoo|ymail|rocketmail|hotmail|outlook|live|msn)(\.[a-z]{2,})+)$/i;

export const isFreeEmailAddress = (email) => {
  const domain = String(email || "").split("@")[1]?.trim() || "";
  return FREE_EMAIL_DOMAIN.test(domain);
};

export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD800-\uDFFF])/;

  if (!email || email.trim() === "") {
    return "Email is required";
  }

  if (email !== email.trim()) {
    return "Email should not contain leading or trailing spaces";
  }

  if (email.length > 254) {
    return "Email should not exceed 254 characters";
  }

  const [localPart, domainPart] = email.split("@");

  if (!localPart || !domainPart) {
    return "Enter a valid email";
  }

  if (localPart.length > 64) {
    return "Enter a valid email";
  }

  if (domainPart.length > 190) {
    return "Enter a valid email";
  }

  if (emojiRegex.test(email) || !emailRegex.test(email)) {
    return "Enter a valid email";
  }

  return "";
};

export const validateName = (name) => {
  if (!name) return "First Name is required";
  if (name.length < 3) return "Minimum 3 characters required";
  return "";
};

export const validateOrganisationName = (name) => {
  const trimmed = (name || "").trim();
  if (!trimmed) return "";
  if (trimmed.length > 120) return "Organisation name must be 120 characters or less.";
  return "";
};

export const validateLastName = (name) => {
  if (!name) return "Last Name is required";
  if (name.length < 1) return "Minimum 1 character required";
  return "";
};

export const validatePassword = (password) => {
  if (!password) return "Password is required";
  if (password.length < 8) return "Mininum 8 characters required";
  if (password.length > 60) return "Maximum 60 characters allowed";
  return "";
};

export const validatePasswordCheck = (password, confirmPassword) => {
  let result = ""
  if (password !== confirmPassword) {
    result = "Passwords do not match. Please make sure both passwords are the same.";
  }
  return result
}

export const validateConfirmPassword = (password, confirmPassword) => {
  if (!confirmPassword) return "Confirm Password is required";
  return validatePassword(confirmPassword) || validatePasswordCheck(password, confirmPassword)
}

export const validateOTP = (otp) => {
  if (!otp) return "OTP is required";
  if (!/^\d+$/.test(otp) || otp.length !== 6) return "Invalid OTP";
  return "";
};
